import { createReducer } from 'redux-act';
import { createNotification, closeNotification, closeAllNotifications } from './actions';
// $FlowFixMe[signature-verification-failure]
const reducer = createReducer({
  [createNotification]: (state, payload) => {
    const clone = [...state];
    const index = state.findIndex(el => el.id === payload.id);
    if (index > -1) {
      clone[index] = payload;
      return clone;
    }
    return clone.concat(payload);
  },
  [closeNotification]: (state, payload) => state.filter(message => message.id !== payload),
  [closeAllNotifications]: () => []
}, []);
export default reducer;